import type { MessageDescriptor } from "react-intl";

import { ClientGateway } from "@kex/api";

import { formatPhoneNumberDisplay } from "@shared/libs/phone-number";

import { transactionVerifyMessages as msg } from "../ui/messages";

export type OtpDeliveryConfig = {
  contact: string;
  label: MessageDescriptor;
};

export const getOtpDeliveryConfig = (
  profile: ClientGateway.ProfileModel,
): OtpDeliveryConfig => {
  const isSms =
    profile.otpPreference === ClientGateway.OtpDeliveryTypesEnum.SMS &&
    profile.security.phoneChecked;

  return isSms
    ? {
        contact: formatPhoneNumberDisplay(profile.phone),
        label: msg.otpSmsLabel,
      }
    : { contact: profile.email, label: msg.otpEmailLabel };
};
